var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.72 25.946C20.4382 25.946 25.8844 20.4998 25.8844 13.7816C25.8844 7.06321 20.4382 1.61719 13.72 1.61719C7.00169 1.61719 1.55566 7.06321 1.55566 13.7816C1.55566 20.4998 7.00169 25.946 13.72 25.946ZM13.72 25.946V15.7542M13.72 15.7542V11.1514C13.72 9.33565 15.1919 7.86376 17.0077 7.86376H18.6516M13.72 15.7542H10.1036M13.72 15.7542H17.3365",
    stroke: "#3D4910",
    strokeWidth: 2.63014,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.35a92338d4312328954af253e1fff60d.svg";
export { ForwardRef as ReactComponent };